import { MAX_PARTY_SIZE } from './constants';

/** A crucible's party size: the most members it takes, and the fewest its run can start with (#206). */
export interface PartySize {
    readonly maxPlayers: number;
    readonly minPlayers: number;
}

/**
 * Why a party size is not allowed, or null when it is: a crucible takes 1
 * to `MAX_PARTY_SIZE` members, and its run starts with 1 to all of them.
 */
export function findPartySizeError({ maxPlayers, minPlayers }: PartySize): string | null {
    if (maxPlayers < 1 || maxPlayers > MAX_PARTY_SIZE) {
        return `maxPlayers must be between 1 and ${MAX_PARTY_SIZE}.`;
    }
    if (minPlayers < 1 || minPlayers > maxPlayers) {
        return `minPlayers must be between 1 and maxPlayers (${maxPlayers}).`;
    }
    return null;
}

/** The most members a crucible may take when its recipe or template declares `declaredMax` (or nothing): never past `MAX_PARTY_SIZE`. */
export function resolvePlayerCap(declaredMax: number | undefined): number {
    return Math.min(MAX_PARTY_SIZE, declaredMax ?? MAX_PARTY_SIZE);
}

/** Whether a crucible is made for a party (chat, invites): it takes more than one member. */
export function isPartyCrucible(crucible: { readonly maxPlayers: number }): boolean {
    return crucible.maxPlayers > 1;
}
